<template>
  <view class="pft-radio-group" :style="style">
    <slot></slot>
  </view>
</template>

<script setup lang="ts">
import { reactive, provide } from "vue"

// 实现 v-model的绑定
const props = withDefaults(
  defineProps<{
    modelValue: string
    style: { [key: string]: string }
  }>(),
  {
    modelValue: () => "",
    style: () => ({}),
  },
)

const state = reactive({
  modelValue: props.modelValue,
})

provide("modelValue", state)

const emit = defineEmits(["update:modelValue"])

const updateValue = value => {
  // 这里获取到的是默认插槽的vnode，但拿不到对应的dom实例
  emit("update:modelValue", value)
  // 通知子组件
  state.modelValue = value
}

defineExpose({
  updateValue,
})
</script>

<style lang="scss">
.pft-radio-group {
  display: flex;
  flex-direction: column;
}
</style>
